<template>
  <el-dialog
    :visible="true"
    :close-on-click-modal="false"
    :show-close="true"
    :before-close="beforeClose"
    :modal-append-to-body="false"
    width="750px"
    :title="
      $t('Audiences_SegmentEvaluations_ChannelReach_DialogTitle', {
        date: dateCreated
      })
    "
    center
  >
    <segment-counts-top-bar
      :metrics="taskData.task.count"
      type="channels"
      :columns="3"
    />

    <div style="padding: 0 20px; line-height: 30px">
      {{ $t('Audiences_SegmentEvaluations_ChannelReach_Option_Title') }}
      <br />
      &nbsp; -
      {{ $t('Audiences_SegmentEvaluations_ChannelReach_Option_Subscription') }}:
      <b>{{ taskData.task.subscription ? 'Yes' : 'No' }}</b>
      <br />
      &nbsp; -
      {{ $t('Audiences_SegmentEvaluations_ChannelReach_Option_Suppression') }}:
      <b>{{ taskData.task.suppression ? 'Yes' : 'No' }}</b>
      <br />
      &nbsp; -
      {{
        $t(
          'Audiences_SegmentEvaluations_ChannelReach_Option_EngagementCategory'
        )
      }}:
      <b>{{ taskData.task.categoryId ? taskData.task.categoryId : 'None' }}</b>
    </div>
  </el-dialog>
</template>

<script>
import SegmentCountsTopBar from '@/modules/audiences/components/SegmentCountsTopBar'
import { EventBus } from '@/core/EventBus'
import moment from 'moment'
export default {
  name: 'ChannelReachPreviewDialog',
  components: { SegmentCountsTopBar },
  props: {
    taskData: {
      type: Object,
      required: true
    }
  },
  methods: {
    beforeClose() {
      EventBus.$emit('close-channel-reach-preview-dialog')
    }
  },
  computed: {
    dateCreated() {
      return this.taskData
        ? moment(this.taskData.create_time * 1000).format('DD-MMM-YYYY HH:mm')
        : null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/audiences/components/ChannelReachPreviewDialog.vue